import styled, {css} from "styled-components";
import {Link} from "gatsby";

const Button = styled(Link)`
  display: inline-block;
  
  color: var(--color-silver-border);
  font-size: 26px;
  font-weight: 300;
  text-transform: uppercase;
  text-align: center;
  
  border: 2px solid var(--color-silver-border);
  border-radius: 25px;
  
  padding: 20px 45px;

  &:hover {
    cursor: pointer;
    color: var(--color-secondary);
    background-color: var(--color-primary);
    border-color: var(--color-primary);
  }

  ${({mini}) => mini && css`
    font-size: 20px;
    border: 1px solid var(--color-silver-border);
    border-radius: 30px;

    padding: 10px 45px;
  `}
`;

export default Button;
